var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _vm.showFilogix && !_vm.onlyShowProfileNumberField
        ? _c(
            "b-row",
            { staticClass: "moregage-form" },
            [
              _c(
                "b-col",
                { staticClass: "mb-2 mb-lg-0", attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "material-input",
                    {
                      attrs: {
                        "label-for": "firm-code",
                        label: _vm.$t("settings.accountTab.firmCode"),
                        "required-indicator":
                          _vm.requireLenderSubmissionDetails,
                      },
                      model: {
                        value: _vm.firmCode,
                        callback: function ($$v) {
                          _vm.firmCode = $$v
                        },
                        expression: "firmCode",
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.firmCode,
                            expression: "firmCode",
                          },
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: {
                              mask: "*{4,4}",
                              definitions: {
                                "*": { casing: "upper", validator: "[\\w]" },
                              },
                              greedy: false,
                              placeholder: "",
                            },
                            expression:
                              "{\n            mask: '*{4,4}',\n            definitions: { '*': { casing: 'upper', validator: '[\\\\w]' } },\n            greedy: false,\n            placeholder: ''\n          }",
                          },
                        ],
                        staticClass: "material-input form-control form",
                        attrs: {
                          id: "firm-code",
                          "data-parsley-minlength": "4",
                          type: "text",
                          name: "firmCode",
                          placeholder: _vm.$t("settings.accountTab.firmCode"),
                        },
                        domProps: { value: _vm.firmCode },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.firmCode = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-2 mb-lg-0", attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "material-input",
                    {
                      attrs: {
                        "label-for": "filogix-user",
                        label: _vm.$t("settings.accountTab.expertLoginId"),
                        "required-indicator":
                          _vm.requireLenderSubmissionDetails,
                      },
                      model: {
                        value: _vm.expertLoginId,
                        callback: function ($$v) {
                          _vm.expertLoginId = $$v
                        },
                        expression: "expertLoginId",
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.expertLoginId,
                            expression: "expertLoginId",
                          },
                        ],
                        staticClass: "material-input form-control form",
                        attrs: {
                          id: "filogix-user",
                          autocomplete: "off",
                          "data-lpignore": "true",
                          type: "text",
                          name: "expertLoginId",
                          placeholder: "Username",
                        },
                        domProps: { value: _vm.expertLoginId },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.expertLoginId = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFilogix
        ? _c(
            "b-row",
            { staticClass: "moregage-form" },
            [
              !_vm.onlyShowProfileNumberField
                ? _c(
                    "b-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-2 mb-lg-0" },
                            [
                              _c(
                                "material-input",
                                {
                                  attrs: {
                                    "label-for": "license-registration-id",
                                    label: _vm.$t(
                                      "settings.accountTab.licenseRegistrationNumber"
                                    ),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "input-icon",
                                        fn: function () {
                                          return [
                                            _c("icon", {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.top.html",
                                                  value:
                                                    _vm.licenseRegistrationNumberTooltip,
                                                  expression:
                                                    "licenseRegistrationNumberTooltip",
                                                  modifiers: {
                                                    top: true,
                                                    html: true,
                                                  },
                                                },
                                              ],
                                              staticClass:
                                                "text-grey ml-1 material-input-icon",
                                              attrs: { name: "info-circle" },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1060295450
                                  ),
                                  model: {
                                    value: _vm.licenseRegistrationNumber,
                                    callback: function ($$v) {
                                      _vm.licenseRegistrationNumber = $$v
                                    },
                                    expression: "licenseRegistrationNumber",
                                  },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.licenseRegistrationNumber,
                                        expression: "licenseRegistrationNumber",
                                      },
                                    ],
                                    staticClass:
                                      "material-input form-control form",
                                    attrs: {
                                      id: "license-registration-id",
                                      autocomplete: "off",
                                      "data-lpignore": "true",
                                      type: "text",
                                      name: "licenseRegistrationNumber",
                                      placeholder: _vm.$t(
                                        "settings.accountTab.licenseRegistrationNumber"
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.licenseRegistrationNumber,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.licenseRegistrationNumber =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-2 mb-lg-0 pr-0 vertical-center" },
                        [
                          _c(
                            "material-input",
                            {
                              attrs: {
                                "label-for": "user-profile-id",
                                label: _vm.$t(
                                  "settings.accountTab.expertProfileNumber"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "input-icon",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              id: "filogix-details-tooltip",
                                            },
                                          },
                                          [
                                            _c("icon", {
                                              staticClass: "tooltip-info",
                                              attrs: {
                                                name: "question-circle",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3280897493
                              ),
                              model: {
                                value: _vm.expertProfileNumber,
                                callback: function ($$v) {
                                  _vm.expertProfileNumber = $$v
                                },
                                expression: "expertProfileNumber",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.expertProfileNumber,
                                    expression: "expertProfileNumber",
                                  },
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: {
                                      mask: "9{0,10}",
                                      showMaskOnHover: false,
                                    },
                                    expression:
                                      "{ mask: '9{0,10}', showMaskOnHover: false }",
                                  },
                                ],
                                staticClass: "material-input form-control form",
                                attrs: {
                                  id: "user-profile-id",
                                  autocomplete: "off",
                                  "data-lpignore": "true",
                                  type: "text",
                                  name: "expertProfileNumber",
                                  placeholder: _vm.$t(
                                    "settings.accountTab.expertProfileNumber"
                                  ),
                                },
                                domProps: { value: _vm.expertProfileNumber },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.expertProfileNumber =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEquifax
        ? _c(
            "b-row",
            { staticClass: "moregage-form" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-2 mb-lg-0" },
                        [
                          _c(
                            "material-input",
                            {
                              attrs: {
                                "label-for": "user-id",
                                label: _vm.$t(
                                  "settings.accountTab.equifaxUserId"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "input-icon",
                                    fn: function () {
                                      return [
                                        _c("icon", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.top.html",
                                              value: _vm.userIdTooltip,
                                              expression: "userIdTooltip",
                                              modifiers: {
                                                top: true,
                                                html: true,
                                              },
                                            },
                                          ],
                                          staticClass:
                                            "text-grey ml-1 material-input-icon",
                                          attrs: { name: "info-circle" },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1573629274
                              ),
                              model: {
                                value: _vm.userId,
                                callback: function ($$v) {
                                  _vm.userId = $$v
                                },
                                expression: "userId",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userId,
                                    expression: "userId",
                                  },
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: {
                                      mask: "*{0,}",
                                      definitions: {
                                        "*": {
                                          casing: "upper",
                                          validator: ".",
                                        },
                                      },
                                      greedy: false,
                                    },
                                    expression:
                                      "{\n                mask: '*{0,}',\n                definitions: { '*': { casing: 'upper', validator: '.' } },\n                greedy: false\n              }",
                                  },
                                ],
                                staticClass: "material-input form-control form",
                                attrs: {
                                  id: "user-id",
                                  autocomplete: "off",
                                  "data-lpignore": "true",
                                  type: "text",
                                  name: "userId",
                                  placeholder: _vm.$t(
                                    "settings.accountTab.equifaxUserId"
                                  ),
                                },
                                domProps: { value: _vm.userId },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.userId = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-2 mb-lg-0" },
                        [
                          _c(
                            "material-input",
                            {
                              attrs: {
                                "label-for": "subscriber-number",
                                label: _vm.$t(
                                  "settings.accountTab.equifaxSubscriberNumber"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "input-icon",
                                    fn: function () {
                                      return [
                                        _c("icon", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.top.html",
                                              value:
                                                _vm.subscriberNumberTooltip,
                                              expression:
                                                "subscriberNumberTooltip",
                                              modifiers: {
                                                top: true,
                                                html: true,
                                              },
                                            },
                                          ],
                                          staticClass:
                                            "text-grey ml-1 material-input-icon",
                                          attrs: { name: "info-circle" },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                4143664442
                              ),
                              model: {
                                value: _vm.subscriberNumber,
                                callback: function ($$v) {
                                  _vm.subscriberNumber = $$v
                                },
                                expression: "subscriberNumber",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.subscriberNumber,
                                    expression: "subscriberNumber",
                                  },
                                ],
                                staticClass: "material-input form-control form",
                                attrs: {
                                  id: "subscriber-number",
                                  autocomplete: "off",
                                  "data-lpignore": "true",
                                  type: "password",
                                  name: "subscriberNumber",
                                  placeholder: _vm.$t(
                                    "settings.accountTab.equifaxSubscriberNumber"
                                  ),
                                },
                                domProps: { value: _vm.subscriberNumber },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.subscriberNumber = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEquifax
        ? _c(
            "b-row",
            { staticClass: "moregage-form" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-2 mb-lg-0" },
                        [
                          _c(
                            "material-input",
                            {
                              attrs: {
                                "label-for": "subscriber-security-code",
                                label: _vm.$t(
                                  "settings.accountTab.equifaxSubscriberSecurityCode"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "input-icon",
                                    fn: function () {
                                      return [
                                        _c("icon", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.top.html",
                                              value:
                                                _vm.subscriberSecurityCodeTooltip,
                                              expression:
                                                "subscriberSecurityCodeTooltip",
                                              modifiers: {
                                                top: true,
                                                html: true,
                                              },
                                            },
                                          ],
                                          staticClass:
                                            "text-grey ml-1 material-input-icon",
                                          attrs: { name: "info-circle" },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3921706554
                              ),
                              model: {
                                value: _vm.subscriberSecurityCode,
                                callback: function ($$v) {
                                  _vm.subscriberSecurityCode = $$v
                                },
                                expression: "subscriberSecurityCode",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.subscriberSecurityCode,
                                    expression: "subscriberSecurityCode",
                                  },
                                ],
                                staticClass: "material-input form-control form",
                                attrs: {
                                  id: "subscriber-security-code",
                                  autocomplete: "new-password",
                                  "data-lpignore": "true",
                                  type: "password",
                                  name: "subscriberSecurityCode",
                                  placeholder: _vm.$t(
                                    "settings.accountTab.equifaxSubscriberSecurityCode"
                                  ),
                                },
                                domProps: { value: _vm.subscriberSecurityCode },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.subscriberSecurityCode =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c(
                    "div",
                    { staticClass: "col mb-2 mb-lg-0" },
                    [
                      _c(
                        "material-input",
                        {
                          attrs: {
                            "label-for": "subscriber-password",
                            label: _vm.$t(
                              "settings.accountTab.equifaxSubscriberPassword"
                            ),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input-icon",
                                fn: function () {
                                  return [
                                    _c("icon", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.top.html",
                                          value: _vm.subscriberPasswordTooltip,
                                          expression:
                                            "subscriberPasswordTooltip",
                                          modifiers: { top: true, html: true },
                                        },
                                      ],
                                      staticClass:
                                        "text-grey ml-1 material-input-icon",
                                      attrs: { name: "info-circle" },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            109331002
                          ),
                          model: {
                            value: _vm.subscriberPassword,
                            callback: function ($$v) {
                              _vm.subscriberPassword = $$v
                            },
                            expression: "subscriberPassword",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.subscriberPassword,
                                expression: "subscriberPassword",
                              },
                            ],
                            staticClass: "material-input form-control form",
                            attrs: {
                              id: "subscriber-password",
                              autocomplete: "off",
                              "data-lpignore": "true",
                              type: "password",
                              name: "subscriberPassword",
                              placeholder: _vm.$t(
                                "settings.accountTab.equifaxSubscriberPassword"
                              ),
                            },
                            domProps: { value: _vm.subscriberPassword },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.subscriberPassword = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }